import type { TripChange, TripCharacteristics } from '@eti/schema-types';
import { getTripNotificationChanges } from '../../../utils/notification';
import type { BoundsType } from '../models';
import FreeCancellationNotification from './notifications/FreeCancellationNotification';
import PriceChangeNotification from './notifications/PriceChangeNotification';
import RyanAirVerificationProcessNotification from './notifications/RyanAirVerificationProcessNotification';
import ScheduleChangeNotification from './notifications/ScheduleChangeNotification';
import StopLossPriceChangeNotification from './notifications/StopLossPriceChangeNotification';
import VoucherNotValidNotification from './notifications/VoucherNotValidNotification';

interface PaymentNotificationsProps {
  bounds: BoundsType;
  isPotentialStopLossChange: boolean;
  tripChanges: TripChange[];
  tripCharacteristics: TripCharacteristics[];
}

const PaymentNotifications = ({
  bounds,
  isPotentialStopLossChange,
  tripChanges,
  tripCharacteristics = [],
}: PaymentNotificationsProps) => {
  const tripChange = getTripNotificationChanges(tripChanges, bounds);

  return (
    <>
      <VoucherNotValidNotification tripCharacteristics={tripCharacteristics} />
      <PriceChangeNotification tripChange={tripChange} />
      <StopLossPriceChangeNotification
        isPotentialStopLossChange={isPotentialStopLossChange}
        tripChange={tripChange}
      />
      <ScheduleChangeNotification tripChange={tripChange} />
      <FreeCancellationNotification bounds={bounds} />
      <RyanAirVerificationProcessNotification bounds={bounds} />
    </>
  );
};

export default PaymentNotifications;
